import React from "react";
import {
  BackHeader,
  MostPopularCoursesNavbar,
  SideMenu,
} from "./../../components";
import CoverImage from "./../../../assets/images/profileHeader.png";
import { GrFacebookOption, GrTwitter } from "react-icons/gr";
import { FaLinkedinIn, FaWhatsapp } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

let OurLatestUpdateDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div>
      {location.state.type === "unauthorized" ? (
        <div>
          <MostPopularCoursesNavbar />
          <div className="page-details-container">
            <BackHeader backHanler={() => navigate(-1)} />

            <img src={CoverImage} className="data-view-header-cover-image" />
            <div className="data-view-cover-footer-container">
              <div className="data-view-cover-footer">
                <p className="data-view-cover-footer-date">
                  14 march 2022
                </p>
              </div>
            </div>

            <div className="data-view-cover-footer-container">
              <div className="data-view-cover-footer">
                <p className="data-view-cover-footer-date"></p>
              </div>
              <div className="share-main">
                <p className="data-view-cover-footer-data">share</p>
                <div>
                  <button className="share-button">
                    <GrFacebookOption color="white" size={20} />
                  </button>
                  <button className="share-button">
                    <FaLinkedinIn color="white" size={20} />
                  </button>
                  <button className="share-button">
                    <GrTwitter color="white" size={20} />
                  </button>
                  <button className="share-button">
                    <FaWhatsapp color="white" size={20} />
                  </button>
                </div>
              </div>
            </div>
            <p className="description-heading">Discription</p>
            <p className="data-view-description">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. In in
              lorem congue, euismod urna vitae, porttitor mi. Aliquam
              consectetur eu turpis ac congue. <br /> <br />
              Curabitur viverra nunc cursus est efficitur, sit amet ornare felis
              accumsan. Ut eget elementum sem. Sed et nibh pharetra. Lorem ipsum
              dolor sit amet, consectetur adipiscing elit. In in lorem congue,
              euismod urna vitae, porttitor mi. Aliquam consectetur eu turpis ac
              congue. <br /> <br />
              Curabitur viverra nunc cursus est efficitur, sit amet ornare felis
              accumsan. Ut eget elementum sem. Sed et nibh pharetra. <br />{" "}
              <br />
              Fusce non porttitor mi. Pellentesque lacus tortor, placerat sit
              amet condimentum eu, placerat id urna. Nunc tellus purus,
              porttitor vel faucibus at, sagittis eget neque. Vivamus quis magna
              est. Pellentesque in finibus turpis, eget feugiat leo. In
              ullamcorper maximus magna non fringilla. <br /> <br />
              Morbi ante dui, pulvinar vitae urna eu, pretium pretium nulla.
              Praesent ultricies sapien vitae sapien lacinia facilisis. Nam in
              ipsum id nibh mollis semper sit amet in erat. Suspendisse finibus
              placerat eros id interdum. Curabitur mattis augue erat, ut posuere
              nisi molestie sed. <br /> <br />
              Fusce vel arcu a nisl viverra rhoncus. Donec vel sagittis lacus.
              Sed id quam et quam malesuada dignissim sit amet eu massa. Aenean
              euismod orci eu sem volutpat, vitae consequat nulla fringilla.{" "}
              <br /> <br />
              Curabitur massa sem, ullamcorper rhoncus euismod at, luctus vel
              velit. Fusce neque felis, vehicula sit amet massa eu, euismod
              tempor nulla. Duis iaculis orci ut euismod venenatis. Vestibulum
              eu sem id tortor mollis mollis blandit tristique eros. Nam
              pulvinar ultricies arcu at fermentum.
            </p>
          </div>
        </div>
      ) : (
        <SideMenu>
          <div className="page-details-container">
            <BackHeader backHanler={() => navigate(-1)} />

            <img src={CoverImage} className="data-view-header-cover-image" />
            <div className="data-view-cover-footer-container">
              <div className="data-view-cover-footer">
                <p className="data-view-cover-footer-date">
                  14 march 2022
                </p>
              </div>
            </div>

            <div className="data-view-cover-footer-container">
              <div className="data-view-cover-footer">
                <p className="data-view-cover-footer-date"></p>
              </div>
              <div className="share-main">
                <p className="data-view-cover-footer-data">share</p>
                <div>
                  <button className="share-button">
                    <GrFacebookOption color="white" size={20} />
                  </button>
                  <button className="share-button">
                    <FaLinkedinIn color="white" size={20} />
                  </button>
                  <button className="share-button">
                    <GrTwitter color="white" size={20} />
                  </button>
                  <button className="share-button">
                    <FaWhatsapp color="white" size={20} />
                  </button>
                </div>
              </div>
            </div>
            <p className="description-heading">Discription</p>
            <p className="data-view-description">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. In in
              lorem congue, euismod urna vitae, porttitor mi. Aliquam
              consectetur eu turpis ac congue. <br /> <br />
              Curabitur viverra nunc cursus est efficitur, sit amet ornare felis
              accumsan. Ut eget elementum sem. Sed et nibh pharetra. Lorem ipsum
              dolor sit amet, consectetur adipiscing elit. In in lorem congue,
              euismod urna vitae, porttitor mi. Aliquam consectetur eu turpis ac
              congue. <br /> <br />
              Curabitur viverra nunc cursus est efficitur, sit amet ornare felis
              accumsan. Ut eget elementum sem. Sed et nibh pharetra. <br />{" "}
              <br />
              Fusce non porttitor mi. Pellentesque lacus tortor, placerat sit
              amet condimentum eu, placerat id urna. Nunc tellus purus,
              porttitor vel faucibus at, sagittis eget neque. Vivamus quis magna
              est. Pellentesque in finibus turpis, eget feugiat leo. In
              ullamcorper maximus magna non fringilla. <br /> <br />
              Morbi ante dui, pulvinar vitae urna eu, pretium pretium nulla.
              Praesent ultricies sapien vitae sapien lacinia facilisis. Nam in
              ipsum id nibh mollis semper sit amet in erat. Suspendisse finibus
              placerat eros id interdum. Curabitur mattis augue erat, ut posuere
              nisi molestie sed. <br /> <br />
              Fusce vel arcu a nisl viverra rhoncus. Donec vel sagittis lacus.
              Sed id quam et quam malesuada dignissim sit amet eu massa. Aenean
              euismod orci eu sem volutpat, vitae consequat nulla fringilla.{" "}
              <br /> <br />
              Curabitur massa sem, ullamcorper rhoncus euismod at, luctus vel
              velit. Fusce neque felis, vehicula sit amet massa eu, euismod
              tempor nulla. Duis iaculis orci ut euismod venenatis. Vestibulum
              eu sem id tortor mollis mollis blandit tristique eros. Nam
              pulvinar ultricies arcu at fermentum.
            </p>
          </div>
        </SideMenu>
      )}
    </div>
  );
};
export default OurLatestUpdateDetails;
